import { render } from "./Impressum.vue?vue&type=template&id=3ab094bd&scoped=true&ts=true"
import script from "./Impressum.vue?vue&type=script&lang=ts"
export * from "./Impressum.vue?vue&type=script&lang=ts"

import "./Impressum.vue?vue&type=style&index=0&id=3ab094bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab094bd"]])

export default __exports__